import { WhereClausePreviewProps } from '@modules/common/components/WhereClausePreview/WhereClausePreview';
import { MeasuredAsMetricCompareDenominatorPreview } from '@modules/quantify/components/QuantifyQueryBuilder/Fields/MeasuredAsField/MeasuredAsMetricCompareDenominatorPreview';
import { MeasuredAsMetricDenominatorPreview } from '@modules/quantify/components/QuantifyQueryBuilder/Fields/MeasuredAsField/MeasuredAsMetricDenominatorPreview';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Stack, SxProps, Theme, Typography } from '@mui/material';
import { useState } from 'react';
import { EQLFunctionName } from 'v2/core/repository/eql/types';

interface MeasuredAsMetricDenominatorProps {
  sx?: SxProps<Theme>;
  isReadOnly?: boolean;
  whereClausePreviewProps?: Partial<WhereClausePreviewProps>;
}

export function MeasuredAsMetricDenominator({
  sx,
  isReadOnly,
  whereClausePreviewProps,
}: MeasuredAsMetricDenominatorProps) {
  const isCompareToByWhereClauseType = useQuantifyStore(
    ({ query }) => query.compareQuery?.whereClause,
  );
  const isNormaliseByPercentFormula = useQuantifyStore(
    ({ query }) =>
      query.formulaQuery?.eqlFunction === EQLFunctionName.NormaliseByPercent,
  );
  const measuredAsCriteria = useQuantifyStore(
    ({ query }) => query.formulaQuery?.criteria,
  );

  const [shouldOpenQBModal, setShouldOpenQBModal] = useState(false);

  const editIcon =
    isReadOnly || isCompareToByWhereClauseType ? null : (
      <IconButton
        size="small"
        onClick={() => setShouldOpenQBModal(true)}
        aria-label="open-denominator-qb-modal-btn"
      >
        <EditIcon fontSize="inherit" />
      </IconButton>
    );

  if (!isNormaliseByPercentFormula) {
    return null;
  }

  return (
    <Stack
      direction="column"
      spacing={1}
      sx={sx}
      data-testid="denominator-where-clause-field"
    >
      <Stack direction="row" alignItems="center">
        <Typography variant="caption">
          <Typography variant="inherit" component="span">
            Denominator is{' '}
          </Typography>
          <Typography
            variant="inherit"
            component="span"
            sx={{
              opacity: 0.6,
            }}
          >
            All {measuredAsCriteria?.displayName} with following Filters
          </Typography>
        </Typography>
        {editIcon}
      </Stack>
      {isCompareToByWhereClauseType ? (
        <Stack direction="column" spacing={1}>
          <MeasuredAsMetricCompareDenominatorPreview
            isFilterA={true}
            isReadOnly={isReadOnly}
            whereClausePreviewProps={whereClausePreviewProps}
          />
          <MeasuredAsMetricCompareDenominatorPreview
            isFilterA={false}
            isReadOnly={isReadOnly}
            whereClausePreviewProps={whereClausePreviewProps}
          />
        </Stack>
      ) : (
        <MeasuredAsMetricDenominatorPreview
          isReadOnly={isReadOnly}
          whereClausePreviewProps={whereClausePreviewProps}
          shouldOpenQBModal={shouldOpenQBModal}
          setShouldOpenQBModal={setShouldOpenQBModal}
        />
      )}
    </Stack>
  );
}
